module.exports = __webpack_public_path__ + "static/media/whichThinnerRecommended.7bb08432.mp3";